export const getFitnessPreferenceLabelByName = (name) => {
  switch (name) {
    case 'outdoor':
      return 'Outdoor (Hiking, Walking, Jogging, Running)';
    case 'gym':
      return 'Gym (Weights, Cardio)';
    case 'studio':
      return 'Studio/Home (Yoga, Pilates, Dance, Cardio)';
    case 'office':
      return 'Office (Stretches)';
    default:
      return name;
  }
};

export const getNutritionPreferenceLabelByName = (name) => {
  switch (name) {
    case 'vegetarian':
      return 'Vegetarian';
    case 'vegan':
      return 'Vegan';
    case 'pescatarian':
      return 'Pescatarian';
    case 'pork_free':
      return 'Pork Free';
    case 'none':
      return 'None';
    default:
      return name;
  }
};
